export const currentEditor = (state) => {
  return state.currentEditor;
};
export const currentInlay = (state) => {
  return JSON.parse(JSON.stringify(state.currentInlay));
};
export const currentInlayProjectName = (state) => {
  return state.currentInlay["project-name"];
};
export const currentBackgroundColor = (state) => {
  if (!state.currentInlay.name.includes("gt6l")) {
    return state.currentInlay.inlay.style["background-color"];
  } else {
    return state.currentInlay.inlay[state.selectedGT6LInlay].style[
      "background-color"
    ];
  }
};
export const currentBackgroundImg = (state) => {
  return state.currentInlay.backgroundImg;
};
export const currentInlayShowImg = (state) => {
  return state.currentInlay.showImg;
};
export const currentInlayBtns = (state) => {
  if (!state.currentInlay.name.includes("gt6l")) {
    return state.currentInlay.inlay.btns;
  } else {
    return state.currentInlay.inlay[state.selectedGT6LInlay].btns;
  }
};
// export const currentInlayBtnPos = (state) => {
//   return state.currentInlay.pos;
// };
export const selectedButtons = (state) => {
  return state.selectedBtns;
};
export const currentBgImgTransform = (state) => {
  return state.currentInlay.bgImgTransform;
};
export const currentBgPos = (state) => {
  // console.log(state.currentInlay.inlay);
  return state.currentInlay.inlay.style["background-position"];
};
export const currentLEDs = (state) => {
  return state.currentInlay.inlay.leds;
};
export const currentLEDRad = (state) => {
  return state.currentInlay.inlay.ledRad;
};
export const showLEDs = (state) => {
  if (!state.currentInlay.name.includes("gt6l")) {
    return state.currentInlay.inlay.showLEDs;
  } else {
    return state.currentInlay.inlay[state.selectedGT6LInlay].showLEDs;
  }
};
export const showBarG = (state) => {
  return state.currentInlay.inlay.showBargraph;
};
export const showBargraphCaptions = (state) => {
  return state.currentInlay.inlay.showBargraphCaptions;
};
export const selectedBarG = (state) => {
  return state.selectedBarG;
};
export const selectedBarGLEDs = (state) => {
  return state.selectedBarGLEDs;
};
export const parsedInlays = (state) => {
  return JSON.parse(JSON.stringify(state.parsedInlays));
};
export const currentProject = (state) => {
  return JSON.parse(JSON.stringify(state.currentProject));
};
export const currentProjectName = (state) => {
  return state.currentProjectName;
};
export const inlaySave = (state) => {
  return state.inlaySave;
};
export const draggableTexts = (state) => {
  if (!state.currentInlay.name.includes("gt6l")) {
    return state.currentInlay.inlay.draggableTexts;
  } else {
    return state.currentInlay.inlay[state.selectedGT6LInlay].draggableTexts;
  }
};
export const draggingText = (state) => {
  return state.draggingText;
};
export const imgs = (state) => {
  return state.imgs;
};
export const gtBackground = (state) => {
  return state.currentInlay.gtBackground;
};
export const lastColor = (state) => {
  return state.lastColor;
};
export const selectedTexts = (state) => {
  return state.selectedTexts;
};
export const moveTexts = (state) => {
  return state.moveTexts;
};
export const selectedLEDs = (state) => {
  return state.selectedLEDs;
};
export const smallKeys = (state) => {
  return state.smallKeys;
};
export const currentGT6LInlay = (state) => {
  return state.selectedGT6LInlay;
};
export const currentInlayBarG = (state) => {
  return state.currentInlay.inlay.bargraph;
};
export const renderComponent = (state) => {
  return state.renderComponent;
};
